import type { DeletionCandidate } from "./types";
import type { TestTarget as OperationLogTestTarget } from "../../services/operationLogService";

/**
 * 削除候補（仕様書に登場しない既存ターゲット）を `operation: "DELETE"` の
 * OperationLogTestTarget に変換する。
 *
 * 変換結果は `resolvedTargets`（仕様書由来の CREATE/UPDATE）と結合して
 * SpecRegistrationHierarchicalView のツリー表示用 targets として使う。
 */
export function deletionCandidatesToTargets(
  candidates: DeletionCandidate[],
): OperationLogTestTarget[] {
  return candidates.map((c) => ({
    test_target_id: c.id,
    name: c.name,
    type: c.type as OperationLogTestTarget["type"],
    parent_test_target_id: c.parentId,
    operation: "DELETE",
    selected: false,
    params: {},
  }));
}
